
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/shopify-guides",
      function () {
        return require("private-next-pages/shopify-guides/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/shopify-guides"])
      });
    }
  